<div class="container">
    <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-file-invoice"></i></span>{{ "NoEvidenceCheck.Header" | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [(selected)]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="grid formgrid p-fluid">
            <div class="field col-6">
              <label>{{ "NoEvidenceCheck.Form.NonGUIId" | translate }}</label>
              <div class="formgrid grid">
                <div class="col">
                  <input
                    type="text"
                    pInputText
                    formControlName="nonGuiIdStart"
                  />
                </div>
                ~
                <div class="col">
                  <input type="text" pInputText formControlName="nonGuiIdEnd" />
                </div>
              </div>
            </div>
            <div class="field col-6">
              <label>{{ "NoEvidenceCheck.Form.GUINo" | translate }}</label>
              <div class="formgrid grid">
                <div class="col">
                  <input type="text" pInputText formControlName="guiNoStart" />
                </div>
                ~
                <div class="col">
                  <input type="text" pInputText formControlName="guiNoEnd" />
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3 laas-calendar">
              <laas-calendar
                  #guiNoDt
                  [title]="'NoEvidenceCheck.Form.GUIDt'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event,'guiNoDt')"
                  [showCustomTime]="false"
                  dateFormat="yy-mm-dd">
              </laas-calendar>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <div class="mb-1">{{
                "NoEvidenceCheck.Form.CarrierPaymentBy" | translate
              }}</div>
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="carrierPaymentByOptions"
                [showClear]="true"
                [disabled]="isForwarder"
                formControlName="carrierPaymentBy"
              ></p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <div class="mb-1">{{ "NoEvidenceCheck.Form.OrgId" | translate }}</div>
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="orgIdOptions"
                [showClear]="true"
                formControlName="billCorp"
              ></p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-3 laas-calendar">
              <laas-calendar
                  #createDt
                  [title]="'Common.Label.CreateDate'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event,'createDt')"
                  [showCustomTime]="false"
                  dateFormat="yy-mm-dd">
              </laas-calendar>
            </div>
            <div class="field col-6">
              <label>{{ "NoEvidenceCheck.Form.Status" | translate }}</label>
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="statusOptions"
                [showClear]="true"
                formControlName="status"
              ></p-dropdown>
            </div>
            <div class="field col-6">
              <label>{{ "NoEvidenceCheck.Form.InoutType" | translate }}</label>
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="inOutTypeOptions"
                [showClear]="true"
                [itemSize]="30"
                [virtualScroll]="true"
                formControlName="inOutType"
              ></p-dropdown>
            </div>
            <div class="field col-6">
              <label>{{
                "NoEvidenceCheck.Form.SourceModel" | translate
              }}</label>
              <p-dropdown
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="sourceModelOptions"
                [showClear]="true"
                [itemSize]="30"
                [virtualScroll]="true"
                formControlName="sourceModel"
              ></p-dropdown>
            </div>
          </div>

          <div class="grid">
            <div class="col">
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Search' | translate }}"
                (click)="searchBtnClick()"
              ></button>
              <button
                pButton
                label="{{ 'Common.Button.Reset' | translate }}"
                (click)="resetBtnClick()"
                class="p-button-secondary ml-2"
              ></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <p-table
      #dataTable
      [columns]="selectedColumns"
      [value]="tableValue"
      [scrollable]="true"
      scrollHeight="500px"
      [reorderableColumns]="true"
      [resizableColumns]="true"
      [totalRecords]="this.pageInfo.totalRecords"
      (onPage)="this.tablePageChange($event)"
      (onSort)="this.tableSort($event)"
      (onRowSelect)="this.doSearchDetailData()"
      [rowsPerPageOptions]="this.pageDropDownList"
      [showCurrentPageReport]="true"
      [paginator]="true"
      [(first)]="first"
      [rows]="100"
      [loading]="isHeaderLoading"
      [lazy]="true"
      currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
      selectionMode="single"
      [(selection)]="selectedRow"
      dataKey="rowId"
      editMode="row"
      class="edittable"
      styleClass="datatable-gridlines datatable-striped mt-2 white-space: nowrap;"
    >
      <ng-template pTemplate="caption">
        <laas-table-column-toggle
          [optionsColumn]="tableColumns"
          [dataTable]="dataTable">
        </laas-table-column-toggle>
        <button
          pButton
          *ngIf="canEditTable"
          type="button"
          label="{{ 'NoEvidenceCheck.Button.EditOrView' | translate }}"
          icon="fas fa-pen"
          class="p-button-warning p-button-raised ml-2"
          (click)="switchEditMode()"
          style="color: white"
        ></button>
        <button
          pButton
          *ngIf="canEditTable"
          type="button"
          label="{{ 'Common.Button.Save' | translate }}"
          [disabled]="!editMode"
          icon="fas fa-save"
          (click)="saveBtnClick()"
          class="p-button-raised ml-2"
        ></button>
        <button
          pButton
          *ngIf="canEditTable"
          type="button"
          label="{{ 'Common.Button.DownloadExcel' | translate }}"
          icon="fas fa-save"
          class="p-button-raised ml-2"
          [disabled]="editMode"
          (click)="nonGovermentUniformInvoiceExcelBtn()"
        ></button>
        <button
          pButton
          *ngIf="canEditTable"
          type="button"
          label="{{ 'NoEvidenceCheck.Button.NonGuiNoExcelUpload' | translate }}"
          icon="fas fa-save"
          class="p-button-raised ml-2"
          [disabled]="editMode"
          (click)="uploadClickBtn()"
        ></button>
        <button
          pButton
          pRipple
          *ngIf="isBtnApproveVisible"
          label="{{ 'Common.Button.Approve' | translate }}"
          [disabled]="editMode"
          (click)="approveBtnClick()"
          class="ml-2"
        ></button>
        <button
          pButton
          pRipple
          *ngIf="canEditTable"
          label="{{ 'NoEvidenceCheck.Button.Apply' | translate }}"
          [disabled]="editMode"
          (click)="addBtnClick()"
          class="ml-2"
        ></button>
        <button
          pButton
          pRipple
          *ngIf="isBtnApproveVisible"
          label="{{ 'Common.Button.Return' | translate }}"
          [disabled]="editMode"
          (click)="rejectBtnClick()"
          class="ml-2"
        ></button>
      </ng-template>

      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col style="width: 3vw" />
          <col *ngFor="let col of columns" style="width: 14.8vw" />
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th>
            <p-checkbox
              [(ngModel)]="headerChecked"
              [binary]="true"
              (onChange)="selectAllOrUnSelectAll($event)"
            ></p-checkbox>
          </th>
          <th
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            *ngFor="let col of columns"
            pResizableColumn
            pReorderableColumn
          >
            {{ col.header }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr
          [pSelectableRow]="rowData"
          [pEditableRow]="rowData"
          (click)="onRowClick(rowData)"
          style="height:40px"
          [ngClass]="{
            'row-red': rowData.amountDifferenceColorFlag === 'R',
            'row-yellow': rowData.amountDifferenceColorFlag === 'Y'
          }"
        >
          <td>
            <p-checkbox
              [value]="rowData"
              [(ngModel)]="selectedRowsWithCheckBox"
            ></p-checkbox>
          </td>
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'billCorp'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: orgIdOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'carrierPaymentBy'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: carrierPaymentByOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'status'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: statusOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'paymentMethod'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: carrierPaymentByOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'termsId'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: termsIdOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <p-cellEditor *ngSwitchCase="'guiAmount'" class="p-fluid">
                <ng-template pTemplate="input">
                  <p-inputNumber
                    mode="decimal"
                    [minFractionDigits]="4"
                    [(ngModel)]="rowData[col.field]"
                  ></p-inputNumber>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | number: "1.4-4"
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'amount'" class="p-fluid">
                <ng-template pTemplate="input">
                  <p-inputNumber
                    [disabled]="true"
                    mode="decimal"
                    [minFractionDigits]="4"
                    [(ngModel)]="rowData[col.field]"
                  ></p-inputNumber>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | number: "1.4-4"
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'guiNo'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="flex-column-container">
                    <input
                      pInputText
                      type="text"
                      required
                      [(ngModel)]="rowData[col.field]"
                    />
                    <small *ngIf="rowData[col.field] && rowData[col.field].length > 30" class="p-invalid">
                      {{ 'NoEvidenceCheck.Message.GuiNoMaxLength' | translate }}
                    </small>
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="flex-column-container">
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith: "-" }}
                    </div>
                    <small *ngIf="rowData[col.field] && rowData[col.field].length > 30" class="p-invalid">
                      {{ 'NoEvidenceCheck.Message.GuiNoMaxLength' | translate }}
                    </small>
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'guiDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <p-calendar
                    appendTo="body"
                    dateFormat="yy-mm-dd"
                    [showTime]="true"
                    [(ngModel)]="rowData[col.field]"
                  ></p-calendar>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'guiCurrency'" class="p-fluid">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="currencyOptions"
                    [showClear]="true"
                    appendTo="body"
                    [itemSize]="30"
                    [virtualScroll]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  ></p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: currencyOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor
                *ngSwitchCase="'shippingDescription'"
                class="p-fluid"
              >
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    required
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor
                *ngSwitchCase="'amountDifferenceDescription'"
                class="p-fluid"
              >
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    required
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <ng-container *ngSwitchCase="'sourceModel'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: sourceModelOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <ng-container [ngSwitch]="col.dataType">
                  <p-cellEditor *ngSwitchCase="'date'" class="p-fluid">
                    <ng-template pTemplate="input">
                      <div class="overflow-text">
                        {{
                          rowData[col.field]
                            | date
                              : "yyyy-MM-dd HH:mm"
                              : this.laasSetting.facilityTimeZone
                            | replaceNullWith: "-"
                        }}
                      </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                      <div class="overflow-text">
                        {{
                          rowData[col.field]
                            | date
                              : "yyyy-MM-dd HH:mm"
                              : this.laasSetting.facilityTimeZone
                            | replaceNullWith: "-"
                        }}
                      </div>
                    </ng-template>
                  </p-cellEditor>
                  <ng-container *ngSwitchDefault class="p-fluid">
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith: "-" }}
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="tableColumns.length + 1">
            {{ "Common.Table.NoData" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div style="text-align: center" *ngIf="this.selectedRow">
      <div style="text-align: center">
        <h3>{{ "BillSearch.Text.Count" | translate }}:{{selectedRowsWithCheckBox.length}}，
          {{ "BillSearch.Text.Amount" | translate }}: {{ this.getHeaderRowSum().amount | number: "1.4-4" }}</h3>
      </div>
    </div>
    <laas-data-table
      dataKey="index"
      *ngIf="this.selectedRow"
      [defaultColumns]="detailTableColumns"
      [value]="detailTableValue"
      [totalRecords]="detailPageInfo.totalRecords"
      [lazy]="true"
      [loading]="isDetailLoading"
      [selectable]="true"
      [rowsPerPageOptions]="[100,300,500]"
      [rows]="100"
      [(selectedRows)]="selectedDetailRowsWithCheckBox"
      (tableOnPage)="detailTablePageChange($event)"
      (tableOnSort)="detailTableSort($event)"
    >
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'invoiceType'">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | optionsMapping: invoiceTypeOptions
                    | replaceNullWith: "-"
                }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'formatType'">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | optionsMapping: formatTypeOptions
                    | replaceNullWith: "-"
                }}
              </div>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <ng-container [ngSwitch]="col.dataType">
                <ng-container *ngSwitchCase="'date'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm:ss"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </td>
      </ng-template>
    </laas-data-table>
    <div style="text-align: center" *ngIf="this.selectedRow">
      <h3>{{ "BillSearch.Text.Count" | translate }}:{{ selectedDetailRowsWithCheckBox.length }}，
        {{ "BillSearch.Text.EstimatedAmount" | translate }}:{{ this.getDetailRowSum().estimatedAmount | number: "1.4-4" }}，
        {{ "BillSearch.Text.Amount" | translate }}:{{ this.getDetailRowSum().amount | number: "1.4-4" }}</h3>
    </div>
  </p-card>
</div>

<p-dialog [(visible)]="showUpload" appendTo="body">
  <ng-template pTemplate="header"> 上傳檔案 </ng-template>
  <ng-template pTemplate="body">
    <div class="formgrid grid">
      <div class="field col-12">
        <label>檔案</label>
        <p-fileUpload
          #fileUpload
          accept=".xls,.xlsx"
          [customUpload]="true"
          (uploadHandler)="fileUploader($event)"
          chooseLabel="選擇"
          uploadLabel="上傳"
          cancelLabel="取消"
        >
        </p-fileUpload>
      </div>
    </div>
  </ng-template>
  <p-footer> </p-footer>
</p-dialog>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
